export function HeroBanner(): string {
  return /*html*/`
    <section style="position: relative; overflow: hidden; padding: 4.5rem 0 3.5rem; background: radial-gradient(circle at 50% 30%, rgba(30, 41, 75, 0.6) 0%, rgba(7, 8, 13, 0.95) 75%); border-bottom: 1px solid rgba(255, 255, 255, 0.06);">
      
      <!-- Visual Backdrop with Generated Artwork -->
      <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; opacity: 0.22; pointer-events: none; z-index: 0;">
        <img 
          src="/images/brand/atomixm-hero-banner.jpg" 
          alt="AtomixM Studios Hero" 
          style="width: 100%; height: 100%; object-fit: cover; filter: saturate(1.4) blur(1px);"
        />
      </div>

      <!-- Ambient Glow Blobs -->
      <div style="position: absolute; top: 15%; left: 10%; width: 350px; height: 350px; background: rgba(0, 242, 254, 0.15); border-radius: 50%; filter: blur(90px); pointer-events: none;"></div>
      <div style="position: absolute; bottom: 10%; right: 10%; width: 400px; height: 400px; background: rgba(168, 85, 247, 0.15); border-radius: 50%; filter: blur(100px); pointer-events: none;"></div>

      <div class="container" style="position: relative; z-index: 1;">
        
        <!-- Header Top Badge -->
        <div style="display: flex; justify-content: center; margin-bottom: 1.5rem;">
          <div class="badge badge-cyan" style="padding: 0.4rem 1rem; font-size: 0.82rem;">
            <sl-icon name="stars" style="font-size: 1rem;"></sl-icon>
            <span>Mass & Multimedia Entertainment Ecosystem</span>
          </div>
        </div>

        <!-- Main Title & Tagline -->
        <div style="text-align: center; max-width: 900px; margin: 0 auto 2.5rem;">
          <h1 style="font-size: clamp(2.5rem, 6vw, 4.2rem); font-weight: 900; line-height: 1.08; margin-bottom: 1.25rem; letter-spacing: -0.03em;">
            Welcome to <span class="text-gradient">ATOMIX<span style="color: #00f2fe;">M</span></span>
          </h1>
          <p style="font-size: clamp(1.1rem, 2vw, 1.35rem); color: #cbd5e1; line-height: 1.6; max-width: 760px; margin: 0 auto 2rem;">
            A next-generation multimedia collective uniting <strong>open-source game engines</strong>, <strong>generative AI music</strong>, <strong>cinematic short films</strong>, and <strong>vibe coding architecture</strong>.
          </p>

          <!-- CTA Buttons -->
          <div style="display: flex; justify-content: center; gap: 1rem; flex-wrap: wrap;">
            <a href="#games" class="btn-cyber" style="background: linear-gradient(135deg, #0575e6 0%, #00f260 100%);">
              <sl-icon name="controller"></sl-icon>
              <span>Explore AtomixGame</span>
            </a>
            <a href="#musics" class="btn-cyber" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
              <sl-icon name="music-note-beamed"></sl-icon>
              <span>Listen AtomixMusics</span>
            </a>
            <a href="#films" class="btn-cyber" style="background: linear-gradient(135deg, #f12711 0%, #f5af19 100%);">
              <sl-icon name="film"></sl-icon>
              <span>Watch AtomixFilms</span>
            </a>
            <a href="#devs" class="btn-cyber" style="background: linear-gradient(135deg, #3a7bd5 0%, #3a6073 100%);">
              <sl-icon name="code-slash"></sl-icon>
              <span>Dev Blog & Code</span>
            </a>
          </div>
        </div>

        <!-- Quick Ecosystem Stats Ribbon -->
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 1.25rem; margin-top: 3.5rem;">
          <div class="glass-panel" style="padding: 1.25rem; text-align: center;">
            <div style="font-size: 1.8rem; font-weight: 800; color: #06d6a0;">AtomixGame</div>
            <div style="font-size: 0.85rem; color: #94a3b8; margin-top: 0.25rem;">Steam & Open Engines</div>
          </div>
          <div class="glass-panel" style="padding: 1.25rem; text-align: center;">
            <div style="font-size: 1.8rem; font-weight: 800; color: #a855f7;">AtomixMusics</div>
            <div style="font-size: 0.85rem; color: #94a3b8; margin-top: 0.25rem;">AI Sound & Suno Pipeline</div>
          </div>
          <div class="glass-panel" style="padding: 1.25rem; text-align: center;">
            <div style="font-size: 1.8rem; font-weight: 800; color: #f97316;">AtomixFilms</div>
            <div style="font-size: 0.85rem; color: #94a3b8; margin-top: 0.25rem;">AI Cinema & Shorts</div>
          </div>
          <div class="glass-panel" style="padding: 1.25rem; text-align: center;">
            <div style="font-size: 1.8rem; font-weight: 800; color: #00d2ff;">AtomixDevs</div>
            <div style="font-size: 0.85rem; color: #94a3b8; margin-top: 0.25rem;">Vibe Coding & Fractals</div>
          </div>
        </div>

      </div>
    </section>
  `;
}
